import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

import Content from './Content'

export interface Props {
  timeRanges: CustomTimeRange[]
  base: boolean
}

const Block = ({ timeRanges, base }: Props) => {
  const paddingBottom = base ? 's24' : 's16'

  return (
    <Box paddingBottom={paddingBottom} gap="s8" width="s200">
      {timeRanges.map((range, idx) => (
        <Content key={`${range.id}_${idx}_${range.rangeKey}`} range={range} base={base} />
      ))}
    </Box>
  )
}

export default Block
